import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-logout on 401 for admin routes (prevents stale-token blank pages)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response && error.response.status;
    const url = error && error.config && error.config.url ? error.config.url : '';
    if (status === 401 && url.includes('/admin/') && !url.includes('/admin/login')) {
      try {
        localStorage.removeItem('adminToken');
      } catch (e) {}
      if (window.location.pathname.startsWith('/admin')) {
        window.location.replace('/admin');
      }
    }
    return Promise.reject(error);
  }
);

// API functions
export const seedDatabase = () => api.post('/seed');

export const loginAdmin = (email, password) => 
  api.post('/admin/login', { email, password });

export const getAdminMe = () => api.get('/admin/me');

// Maintenance
export const forceUpdateLineasFariones = () => api.post('/admin/force-update-lineas-fariones');

// Companies
export const getCompanies = () => api.get('/companies');
export const getAdminCompanies = () => api.get('/admin/companies');
export const getCompany = (id) => api.get(`/companies/${id}`);
export const createCompany = (data) => api.post('/companies', data);
export const updateCompany = (id, data) => api.put(`/companies/${id}`, data);
export const deleteCompany = (id) => api.delete(`/companies/${id}`);

// Coupons
export const getAllCoupons = () => api.get('/coupons');
export const getCompanyCoupons = (companyId) => api.get(`/companies/${companyId}/coupons`);
export const getCoupon = (id) => api.get(`/coupons/${id}`);
export const createCoupon = (data) => api.post('/coupons', data);
export const updateCoupon = (id, data) => api.put(`/coupons/${id}`, data);
export const deleteCoupon = (id) => api.delete(`/coupons/${id}`);

// Coupon Usage
export const registerCouponUsage = (couponId, usedByCompanyId, usedByCompanyName) => 
  api.post(`/coupons/${couponId}/use`, { 
    used_by_company_id: usedByCompanyId, 
    used_by_company_name: usedByCompanyName 
  });

// Statistics
export const getStatistics = (period = null) => {
  const params = period ? `?period=${period}` : '';
  return api.get(`/admin/statistics${params}`);
};

export const exportStatistics = (period = null) => {
  const params = period ? `?period=${period}` : '';
  const token = localStorage.getItem('adminToken');
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  
  // Create a link to download
  const link = document.createElement('a');
  link.href = `${BACKEND_URL}/api/admin/statistics/export${params}`;
  
  // We need to use fetch with auth header for protected endpoint
  return fetch(`${BACKEND_URL}/api/admin/statistics/export${params}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(response => response.blob())
  .then(blob => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `estadisticas_cupones.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  });
};

export default api;
